/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BoardItem/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TaskBoardIcon from 'DesignSystem/TaskBoardIcon/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import UnArchiveModal from './UnArchiveModal/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BoardItem({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Menu/Expanded/BoardsArchived/Content/Boards/Content/BoardItem"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let boardMetadataBoardIconIdValueData = fromData.useDataValue({ viewPath,
context: 'board',
path: 'metadata.board_icon_id',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let boardNameValueData = fromData.useDataValue({ viewPath,
context: 'board',
path: 'name',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="BoardItem.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-sGRRd': dtColorsNeutral200,'--btrr-2-sGRRd': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--btlr-3-sGRRd': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bbrr-4-sGRRd': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bblr-5-sGRRd': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--mt-6-sGRRd': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TaskBoardIcon
  viewPath={`${viewPath}/TaskBoardIcon`}
 opacity="40%"
 width={48}
 height={48}
 iconHeight={18}
 iconWidth={18}
 borderTopRightRadius={0}
 borderBottomRightRadius={0}
 borderTopLeftRadius={dtSpaceMs}
 borderBottomLeftRadius={dtSpaceMs}
 data="board.metadata.board_icon_id"
 iconId={boardMetadataBoardIconIdValueData}
/>
<div
  data-testid="BoardItem.Vertical"
  data-view-path={viewPath}
 style={{'--ml-7-sGRRd': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
/>
</div>
<div
  data-testid="BoardItem.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pr-8-sGRRd': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width={140}
 marginRight={dtSpaceXxs}
 color={dtColorsNeutral400}
 display="inline-block"
 textOverflow="ellipsis"
 overflowX="hidden"
 whiteSpace="nowrap"
 weight="medium"
 data="board.name"
 text={boardNameValueData}
/>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 marginTop={0}
 value={true}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'UnArchiveModal/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'UnArchiveModal/Content'))}
>
{childProps => (
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
)}
</TysiaToggle>
</div>
<UnArchiveModal
  viewPath={`${viewPath}/UnArchiveModal`}
/>
</div>
{children}
</React.Fragment>)
}